@if (data$ | async; as data) {
  <div class="container">
    <div class="row no-gutters">
      <div class="col-12" [ngClass]="{ 'col-lg-6': data.image?.url }">
        <div class="category-content" [ngClass]="{ 'category-content-half-width': data.image?.url }">
          <aimo-breadcrumb
            [hideTitle]="true"
            [showBackLink]="false"
            [addFrontPageLink]="false"
            [contentPageTitle]="data.title">
          </aimo-breadcrumb>
          <div class="category-description">
            <h1>{{ data.title }}</h1>
            <div [innerHTML]="data.text|safeHtml"></div>
          </div>
          @if (categories$ | async; as categories) {
            <div class="sub-categories-wrapper">
              <div class="sub-categories">
                @if (allBulletins$ | async; as allBulletins) {
                  <a
                    (click)="clickCategory()"
                    class="btn-facet btn-sm category"
                    [ngClass]="{ selected: isAllCategoriesSelected() }">
                    {{ 'aimo.bulletin.allCategories' | cxTranslate }}
                    <span class="amount">{{ allBulletins.length }}</span>
                  </a>
                }
                @for (category of categories; track category.code) {
                  <a
                    (click)="clickCategory(category.code)"
                    class="btn-facet btn-sm category link"
                    [ngClass]="{ selected: isSelected(category) }">
                    {{ category.name }}
                    <span class="amount">{{ category.amount }}</span>
                  </a>
                }
              </div>
            </div>
          }
        </div>
      </div>
      @if (data.image?.url) {
        <div class="col-12 col-lg-6">
          <div class="category-image">
            <cx-media [container]="data.image"></cx-media>
          </div>
        </div>
      }
    </div>
  </div>
}
